import { useField, useFormikContext } from 'formik'
import DatePicker from 'react-date-picker'
import Label from '../Label/Label'
import { useState } from 'react'
import { format } from 'date-fns'
const MyDateField = ({
    iconVisibility = true,
    label = `Start Date*`,
    touched,
    errors,
    ...props
}) => {
    const [field] = useField(props)
    const { setFieldValue } = useFormikContext()

    const [error, setError] = useState(false)
    const [touch, setTouch] = useState(false)
    const [focused, setFocused] = useState(false)

    const getFieldClasses = (touched, errors) => {
        const classes = ['']
        if (touched && errors) {
            classes.push('react-datetime-picker__wrapper_error')
        }

        if (touched && !errors) {
            classes.push('react-datetime-picker__wrapper_success')
        }
        return classes.join(' ')
    }

    return (
        <>
            <Label labelText={label} />
            <DatePicker
                className={`d-block mt-1
                    rounded form-control
                    ${focused && 'react-datetime-picker__wrapper_focused'}
                ${error && 'react-datetime-picker__wrapper_error'}
                ${getFieldClasses(
                    touched?.[props?.name],
                    errors?.[props?.name]
                )}
                ${touch && !error && 'react-datetime-picker__wrapper_success'}
                `}
                {...field}
                {...props}
                value={field.value ? new Date(`${field.value}T00:00:00`) : null}
                onChange={(value) => {
                    let val
                    if (value) {
                        setError(false)
                        val = format(value, 'yyyy-MM-dd')
                    } else {
                        setError(true)
                    }
                    setFieldValue(props?.name, val)
                }}
                format="y-MM-dd"
                onFocus={(value) => {
                    setTouch(true)
                    setFocused(true)
                }}
                onBlur={() => {
                    setFocused(false)
                }}
            />
        </>
    )
}

export default MyDateField
